import React from "react";
import "./localfeature.css";
import { Container } from "react-bootstrap";
import {  useNavigate } from "react-router-dom";
import notify from "../../../../Notifcation";
const Localmethod = ({ userData }) => {
  const navegate = useNavigate();
  const checkUserBuild = () => {
    if (userData && userData.user_type === "client") {
      navegate("/user/build");
    } else {
      notify("من فضلك قم بتسجيل الدخول اولاً  ", "error");
      setTimeout(() => {
        navegate("/login");
      }, 3000);
    }
  };
  const checkUserard = () => {
    if (userData && userData.user_type === "client") {
      navegate("/user/ard");
    } else {
      notify("من فضلك قم بتسجيل الدخول اولاً  ", "error");
      setTimeout(() => {
        navegate("/login");
      }, 3000);
    }
  };
  const checkUsermasaed= () => {
    if (userData && userData.user_type === "client") {
      navegate("/user/mesad");
    } else {
      notify("من فضلك قم بتسجيل الدخول اولاً  ", "error");
      setTimeout(() => {
        navegate("/login");
      }, 3000);
    }
  };
  const checkUsershope = () => {
    if (userData && userData.user_type === "client") {
      navegate("/user/shope");
    } else {
      notify("من فضلك قم بتسجيل الدخول اولاً  ", "error");
      setTimeout(() => {
        navegate("/login");
      }, 3000);
    }
  };
  const checkUserads = () => {
    if (userData && userData.user_type === "client") {
      navegate("/user/ads");
    } else {
      notify("من فضلك قم بتسجيل الدخول اولاً  ", "error");
      setTimeout(() => {
        navegate("/login");
      }, 3000);
    }
  };
  const checkUserother = () => {
    if (userData && userData.user_type === "client") {
      navegate("/user/other");
    } else {
      notify("من فضلك قم بتسجيل الدخول اولاً  ", "error");
      setTimeout(() => {
        navegate("/login");
      }, 3000);
    }
  };
  const checkUseaskhal = () => {
    if (userData && userData.user_type === "client") {
      navegate("/user/ash");
    } else {
      notify("من فضلك قم بتسجيل الدخول اولاً  ", "error");
      setTimeout(() => {
        navegate("/login");
      }, 3000);
    }
  };
  return (
    <Container>
      <div className="paymentmethod">
        <div className="naqdi">
          {" "}
          <button onClick={checkUserBuild} className="mainb">
            خدمات البناء  <i className="fa-solid fa-building"></i>
          </button>
        </div>
        <div className="naqdi">
          {" "}
          <button onClick={checkUserard} className="mainb">
            خدمات الأراضي <i className="fa-solid fa-mountain"></i>
          </button>
        </div>    <div className="naqdi">
          {" "}
          <button onClick={checkUseaskhal} className="mainb">
            خدمات الأشغالات <i className="fa-solid fa-gear"></i>
          </button>
        </div>    <div className="naqdi">
          {" "}
          <button onClick={checkUsermasaed} className="mainb">
           خدمات المصاعد <i className="fa-solid fa-elevator"></i>
          </button>
        </div>    <div className="naqdi">
          {" "}
          <button onClick={checkUsershope} className="mainb">
            خدمات المحلات التجارية <i className="fa-solid fa-shop"></i>
          </button>
        </div>    <div className="naqdi">
          {" "}
          <button onClick={checkUserads} className="mainb">
            خدمات الأعلانات <i className="fa-solid fa-headset"></i>
          </button>
        </div>    <div className="naqdi">
          {" "}
          <button onClick={checkUserother} className="mainb">
            خدمات اخرى <i className="fa-solid fa-user-check"></i>
          </button>
        </div>  
      </div>
    </Container>
  );
};

export default Localmethod;
